import React from 'react';
import './ErrorMessage.css';

/**
 * Componente para mostrar mensajes de error
 * @param {Object} props
 * @param {string} props.message - Mensaje de error a mostrar
 * @param {string} props.type - Tipo de error ('error', 'warning', 'info')
 * @param {boolean} props.dismissible - Si se puede cerrar
 * @param {Function} props.onDismiss - Callback cuando se cierra
 */
const ErrorMessage = ({ 
  message, 
  type = 'error', 
  dismissible = false,
  onDismiss = null 
}) => {
  const typeClass = `error-message--${type}`;
  const [isVisible, setIsVisible] = React.useState(true);

  if (!message) return null;

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`error-message ${typeClass}`}>
      <div className="error-message-content">
        <span className="error-message-icon">
          {type === 'error' && '⚠️'}
          {type === 'warning' && '⚠️'}
          {type === 'info' && 'ℹ️'}
        </span>
        <span className="error-message-text">{message}</span>
      </div>
      {dismissible && (
        <button 
          className="error-message-dismiss" 
          onClick={handleDismiss}
          aria-label="Cerrar"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;

